"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsonpathPlus = require("jsonpath-plus");
var _iconsLookup = _interopRequireDefault(require("./../../constants/icons-lookup"));
var _r10CommonComponents = require("r10-common-components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// To determine which unit to display in the UI
var convertToDisplayUnit = function convertToDisplayUnit(unit) {
  switch (unit) {
    case 'SEC':
      return 'min';
    case 'MB':
      return 'bestFit';
    case 'SMS':
      return;
    default:
      break;
  }
};
var getConsumptionsByID = function getConsumptionsByID(consumptions, id, unitsAliases, t, statusIndicator) {
  var _statusIndicator$indi, _status2;
  var consumptionsFormatted = [];
  var status = null;
  consumptions === null || consumptions === void 0 ? void 0 : consumptions.map(function (item) {
    if (item.product[0].id === id) {
      var _item$usageType, _item$usageType2;
      var consumption = _r10CommonComponents.utils.convertUnit(item.bucketBalance[0].remainingValue.amount, item.bucketBalance[0].remainingValue.units, convertToDisplayUnit(item.bucketBalance[0].remainingValue.units), unitsAliases, t);
      var remainingValueName = item.bucketBalance[0].remainingValueName;
      status = (0, _jsonpathPlus.JSONPath)({
        path: statusIndicator.jPath,
        json: item
      });
      var convertRemaining = t('consumptionLeft', {
        consumption: consumption
      });
      var isUNLIMITED = item.bucketCounter.filter(function (item) {
        return item.counterType == 'Allowance' && item.valueName == 'UNLIMITED';
      }).length > 0;
      var RemainingText = item.bucketBalance[0].remainingValue.amount == 0 && isUNLIMITED ? t('unlimited') : convertRemaining;
      var object = {
        iconName: _iconsLookup.default[(_item$usageType = item.usageType) === null || _item$usageType === void 0 ? void 0 : _item$usageType.toLowerCase()],
        percentage: item.bucketBalance[0].remainingValue.amount == 0 && !isUNLIMITED ? 0 : 100,
        topText: {
          left: "".concat(t((_item$usageType2 = item.usageType) === null || _item$usageType2 === void 0 ? void 0 : _item$usageType2.toLowerCase())).concat(remainingValueName ? ": ".concat(remainingValueName) : '')
        },
        consumptionValue: RemainingText
      };
      consumptionsFormatted.push(object);
    }
  });
  var _ref = (_statusIndicator$indi = statusIndicator.indicators.find(function (indicator) {
      var _status;
      return indicator.state === ((_status = status) === null || _status === void 0 ? void 0 : _status[0]);
    })) !== null && _statusIndicator$indi !== void 0 ? _statusIndicator$indi : {},
    _ref$translationKey = _ref.translationKey,
    translationKey = _ref$translationKey === void 0 ? (_status2 = status) === null || _status2 === void 0 ? void 0 : _status2[0] : _ref$translationKey,
    color = _ref.color;
  var consumptionsWithStatus = {
    consumptionList: consumptionsFormatted,
    productStatus: {
      text: t(translationKey),
      state: color,
      showSection: statusIndicator.showSection
    }
  };
  return consumptionsWithStatus;
};
var mapActiveAddons = function mapActiveAddons(data, JPSchema, statusIndicator, unitsAliases, t, detailsLinkHandler, dateFormat) {
  if (!data) return;
  var consumptions = JPSchema ? (0, _jsonpathPlus.JSONPath)({
    path: JPSchema.consumptions,
    json: data
  }).flat() : null;
  var activeAddonsList = JPSchema ? (0, _jsonpathPlus.JSONPath)({
    path: JPSchema.activeAddonsList,
    json: data
  }) : null;
  return activeAddonsList === null || activeAddonsList === void 0 ? void 0 : activeAddonsList.map(function (item) {
    var _item$productOffering;
    var Id = (_item$productOffering = item.productOffering) === null || _item$productOffering === void 0 ? void 0 : _item$productOffering.id;
    var _getConsumptionsByID = _objectSpread({}, getConsumptionsByID(consumptions, Id, unitsAliases, t, statusIndicator)),
      consumptionList = _getConsumptionsByID.consumptionList,
      productStatus = _getConsumptionsByID.productStatus;
    return _objectSpread(_objectSpread({
      id: Id,
      productStatus: productStatus,
      cardHeader: {
        header: item.productOffering.name,
        headerLevel: 2,
        distanceBetweenIconAndHeader: 12
      }
    }, (JPSchema === null || JPSchema === void 0 ? void 0 : JPSchema.isShownRenewAndValiditySection) && {
      renewAndValidity: {
        date: {
          iconName: 'calendar-month',
          iconSize: 3,
          text: t('expiryDate'),
          value: _r10CommonComponents.utils.formatDate(item.productTerm[0].validFor.endDateTime, dateFormat)
        },
        showAutoRenew: false
      }
    }), {}, {
      tileButton: {
        showButton: false,
        linkText: t('details'),
        showLink: true,
        onClickLink: detailsLinkHandler,
        padding: 0
      },
      consumption: {
        consumptionList: consumptionList
      }
    });
  });
};
var _default = mapActiveAddons;
exports.default = _default;